import CartLoader from './cart-loader';

export default class Cart {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {};

      this.reset();
      this.setupEventListeners();
      this.checkForAutoGwpSelection();
    }
  }

  //===========================================================================
  // Resets the cart after history changes
  //===========================================================================

  reset() {
    this.state = {
      samplesModuleOpen: false,
      gwpModuleOpen: false,
      scrollToTop: false,
      isCartPage: !!$('.js-cart-page').length
    };
  }

  //===========================================================================
  // Toggles the cart drawer open or closed
  //===========================================================================

  toggleCartDrawer (e) {
    const $body = $('body');

    e.preventDefault();

    if ($body.hasClass('cart-drawer-active')) {
      this.closeCartDrawer();
    } else {
      this.openCartDrawer();
    }
  }

  //===========================================================================
  // Opens the cart drawer
  //===========================================================================

  openCartDrawer() {
    const $body = $('body');

    $body.removeClass('mobile-nav-active');
    $body.removeClass('account-drawer-active');
    $body.addClass('cart-drawer-active');
  }

  //===========================================================================
  // Closes the cart drawer
  //===========================================================================

  closeCartDrawer() {
    const $body = $('body');

    $body.removeClass('cart-drawer-active');
  }

  //===========================================================================
  // Updates the header cart item count
  //===========================================================================

  updateCartCount(count) {
    const $countIcon = $('.js-cart-count-icon');
    const $countLabel = $('.js-cart-count');

    $countLabel.text(count);

    if (count) {
      $countIcon.removeClass('invisible');
    } else {
      $countIcon.addClass('invisible');
    }
  }

  //===========================================================================
  // Updates the Klarna widget after cart refresh
  //===========================================================================

  updateKlarnaWidget() {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }

  //===========================================================================
  // Re-renders the cart page/drawer
  //===========================================================================

  refreshCart(e) {
    const $cart = $('.js-cart-content');
    const self = this;
    const oldCount = Number($('.js-cart-summary').data('count')) || 0;
    const url = this.state.isCartPage ? '/cart?view=ajaxPage' : '/cart?view=ajaxDrawer';

    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'html',
      success: function (data) {
        const $template = $(data);
        const count = Number($template.find('.js-cart-summary').data('count')) || 0;

        if (self.state.isCartPage && self.state.samplesModuleOpen) {
          $template.find('.js-cart-samples .js-accordion-content').removeClass('display--none').addClass('accordion-active');
          $template.find('.js-cart-samples .js-accordion-header').addClass('open');
        }

        if (self.state.isCartPage && self.state.gwpModuleOpen) {
          $template.find('.js-cart-gwp .js-accordion-content').removeClass('display--none').addClass('accordion-active');
          $template.find('.js-cart-gwp .js-accordion-header').addClass('open');
        }

        $cart.empty().html($template.html());
        self.updateCartCount(count);
        // self.updateKlarnaWidget();

        if (!self.state.isCartPage && e && (e.openDrawer || e.detail?.openDrawer)) {
          self.openCartDrawer();
        }

        if (count > oldCount) {
          self.checkForAutoGwpSelection();
        } else if (count <= 0) {
          self.state.scrollToTop = true;

          setTimeout(() => {
            self.closeCartDrawer();
          }, 1000);
        }

        if (self.state.isCartPage && self.state.scrollToTop) {
          $(document).trigger('scrollToPageTop');
          self.state.scrollToTop = false;
        }
      },
      error: function() {
        console.log('ERROR');
      }
    });
  }

  //===========================================================================
  // Return line numbers of GWP products to remove from cart.
  //===========================================================================

  getGwpItemsToRemove($item, price) {
    const $summary = $('.js-cart-summary');
    const subtotal = $summary.data('subtotal');
    const result = [];

    if (!$item.hasClass('js-gwp-cart-item') && !$item.hasClass('js-sample-cart-item')) {
        let $gifts = $('.js-gwp-cart-item, .js-sample-cart-item:not([data-sample-promotion="true"])');

        if ($gifts.length) {
            $gifts.each((i, gift) => {
                const spendAmount = gift.dataset.gwpSpend_amount * 100;
                const gwpProp = gift.dataset.gwpProp;
                const dataAttributeMap = {
                  '_gwp_product'  : 'data-qual',
                  '_gwp_product_2': 'data-qual2',
                  '_gwp_product_3': 'data-qual3'
                };
                const qualifierAttribute = dataAttributeMap[gwpProp];

                const updatedSubtotal = subtotal - price;
                if (updatedSubtotal < spendAmount) {
                    result.push([$(gift).data('line'), 0]);
                } else if ($item[0].hasAttribute(qualifierAttribute) && document.querySelectorAll(`[${qualifierAttribute}]`).length - 1 === 0) {
                    result.push([$(gift).data('line'), 0]);
                }
            });
        }
    }

    return result;
  }

  //===========================================================================
  // Removes a cart item
  //===========================================================================

  removeCartItem(e) {
    const $target  = $(e.currentTarget);
    const $item    = $target.closest('.js-cart-item');
    const price    = $item.data('line-price');
    const lineNum  = $item.data('line');
    const gwpItems = this.getGwpItemsToRemove($item, price);
    const items    = [[lineNum, 0]].concat(gwpItems);

    e.preventDefault();

    items.sort(function(a, b) { return a[0] - b[0]; });
    this.updateItemQuantities(items);
  }

  //===========================================================================
  // Updates the quantity of a line item by clicking plus or minus
  //===========================================================================

  updateQuantityFromClick(e) {
    const $target = $(e.currentTarget);
    const $item   = $target.closest('.js-cart-item');
    const price   = $item.data('item-price');
    const lineNum = $item.data('line');
    const value   = Number($item.find('.js-cart-item-quantity').val());
    let quantity  = 0;
    let gwpItems  = [];
    let items;

    if ($target.hasClass('plus')) {
      quantity = value + 1;
    } else if (value > 0) {
      quantity = value - 1;
      gwpItems = this.getGwpItemsToRemove($item, price);
    }

    items = [[lineNum, quantity]].concat(gwpItems);
    items.sort(function(a, b) { return a[0] - b[0]; });

    this.updateItemQuantities(items);
  }

  //===========================================================================
  // Adjusts the quantity of an array of line items.
  // Each item in the array should be like this: [line number, quantity]
  // Refreshes the cart after completion.
  //===========================================================================

  updateItemQuantities(items) {
    const item = items.pop();
    const lineNum  = item ? item[0] : null;
    const quantity = item ? item[1] : null;
    const self = this;

    if (lineNum) {
      CartJS.updateItem(lineNum, quantity, {}, {
        "success": function(data) {
          if (items.length) {
            self.updateItemQuantities(items);
          } else {
            self.refreshCart();
          }

          $(document).trigger('cartDrawerQtyChange');
        },
        "error": function(err) {
          self.refreshCart();
          alert('There was an error updating your cart.');
        }
      });
    } else {
      this.refreshCart();
    }
  }

  //===========================================================================
  // Toggles the gift message form
  //===========================================================================

  toggleGiftForm(e) {
    const $switch  = $(e.currentTarget);
    const $options = $('.js-cart-drawer-gift-options');

    if ($switch.hasClass('on')) {
      $switch.removeClass('on');
      $options.slideUp();
      $('.js-cart-drawer-form-gift-message').val('');
      $('.js-cart-drawer-form-gift-from').val('');
      this.enableCheckoutButton();
    } else {
      $switch.addClass('on');
      $options.slideDown();
      this.disableCheckoutButton();
    }
  }

  //===========================================================================
  // Enables or disables the checkout button based on gift form values
  //===========================================================================

  checkIfGiftFormIsValid() {
    const $message = $('.js-cart-drawer-form-gift-message');
    const $name    = $('.js-cart-drawer-form-gift-from');

    if ($message.val() && $name.val()) {
      this.enableCheckoutButton();
    } else {
      this.disableCheckoutButton();
    }
  }

  //===========================================================================
  // Caches info about accordion open/closed status
  //===========================================================================

  checkAccordionModuleStatus(e) {
    const $target = $(e.currentTarget);
    const type = $target.data('type');
    const openStatus = $target.hasClass('open');

    if (type === 'samples') {
      this.state.samplesModuleOpen = openStatus;
      this.state.gwpModuleOpen = false;
    } else if (type === 'gwp') {
      this.state.gwpModuleOpen = openStatus;
      this.state.samplesModuleOpen = false;
    }
  }

  //===========================================================================
  // Adds free samples to cart if the correct number are selected
  //===========================================================================

  onSampleSelection(e) {
    const $target = $(e.currentTarget);
    const $gifts = $target.closest('.js-cart-samples');
    const $selected = $gifts.find('.js-cart-sample-checkbox:checked');
    const giftsToSelect = $gifts.data('to-select') || 1;
    const finalGift = $gifts.data('remaining') == 1;
    const payload = [];

    if ($selected.length === giftsToSelect) {
      if (finalGift) {
        $gifts.addClass('loading-final');
        $gifts.find('.js-accordion-header').click();
        this.state.scrollToTop = true;
        this.state.samplesModuleOpen = false;
        this.state.gwpModuleOpen = false;
      } else {
        $gifts.addClass('loading');
      }

      $selected.each((i, sample) => {
        const value = sample.value;

        if (value) {
          payload.push({
            id: value,
            quantity: 1,
            properties: {
              _free_samples: true
            }
          });
        }
      });

      new CartLoader({ payload: payload });
    }
  }

  //===========================================================================
  // Gets properties to add to GWP items
  //===========================================================================

  getGwpProperties($giftData) {
    const properties = {
      _discount_name: $giftData.data('name') || 'Gift',
      _discount: $giftData.data('discount') || 0,
      _discount_type: $giftData.data('type') || 'pecentage',
      _discount_quantity: $giftData.data('quantity') || 1,
      _discount_to_qualify: $giftData.data('qualify'),
      _invalidate_coupon: $giftData.data('no-code')
    };

    if ($giftData.hasClass('js-cart-gwp-summary'))
      properties._gwp_product = true;
    else if ($giftData.hasClass('js-cart-gwp-summary_2'))
      properties._gwp_product_2 = true;
    else if ($giftData.hasClass('js-cart-gwp-summary_3'))
      properties._gwp_product_3 = true;

    return properties;
  }

  //===========================================================================
  // Adds GWP products to cart if the correct number are selected
  //===========================================================================

  onGwpSelection(e) {
    const $target = $(e.currentTarget);
    const $gifts = $($target[0].closest('.js-cart-gwp') || $target[0].closest('.js-cart-gwp_2') || $target[0].closest('.js-cart-gwp_3'));
    const $giftData = $($gifts[0].querySelector('.js-cart-gwp-summary') || $gifts[0].querySelector('.js-cart-gwp-summary_2') || $gifts[0].querySelector('.js-cart-gwp-summary_3'));
    const $selected = $gifts.find('.js-cart-gwp-checkbox:checked');
    const giftsToSelect = $giftData.data('to-select') || 1;
    const finalGift = $giftData.data('remaining') == 1;
    const payload = [];

    if ($selected.length === giftsToSelect) {
      const properties = this.getGwpProperties($giftData);

      if (finalGift) {
        $gifts.addClass('loading-final');
        $gifts.find('.js-accordion-header').click();
        this.state.scrollToTop = true;
        this.state.samplesModuleOpen = false;
        this.state.gwpModuleOpen = false;
      } else {
        $gifts.addClass('loading');
      }

      $selected.each((i, gift) => {
        const variantId = gift.value;

        if (variantId) {
          payload.push({
            id: variantId,
            quantity: 1,
            properties: properties
          });
        }
      });

      new CartLoader({ payload: payload });
    }
  }

  //===========================================================================
  // Automatically adds a GWP item to the cart if conditions are met
  //===========================================================================

  checkForAutoGwpSelection() {
    let input;
    let $giftData;

    if (document.querySelector('.js-auto-gwp') && document.querySelector('[data-qual]')) {
        input = document.querySelector('.js-auto-gwp');
        $giftData = $(document.querySelector('.js-cart-gwp-summary'));
    } else if (document.querySelector('.js-auto-gwp_2') && document.querySelector('[data-qual2]')) {
        input = document.querySelector('.js-auto-gwp_2');
        $giftData = $(document.querySelector('.js-cart-gwp-summary_2'));
    } else if (document.querySelector('.js-auto-gwp_3') && document.querySelector('[data-qual3]')) {
        input = document.querySelector('.js-auto-gwp_3');
        $giftData = $(document.querySelector('.js-cart-gwp-summary_3'));
    }

    const variantId = input ? input.value : null;

    if (variantId) {
      const properties = this.getGwpProperties($giftData);
      const payload = {
        id: variantId,
        quantity: 1,
        properties: properties
      };

      this.state.scrollToTop = true;

      new CartLoader({ payload: payload });
    }
  }

  //===========================================================================
  // Unselects a gift item from cart by clicking "Remove" in a gift module
  //===========================================================================

  onGiftUnselect(e) {
    const $target = $(e.currentTarget);
    const variantId = $target.val();
    const type = $target.data('type');
    let $lineItemToRemove = $();
    let $gifts = $();

    if (type === 'samples') {
      $gifts = $target.closest('.js-cart-samples');
      $lineItemToRemove = $(`.js-sample-cart-item[data-id="${ variantId }"]`);
    } else if (type === 'gwp') {
      $gifts = $target.closest('.js-cart-gwp');
      $lineItemToRemove = $(`.js-gwp-cart-item[data-id="${ variantId }"]`);
    }

    const $removeButton = $lineItemToRemove.find('.js-remove-cart-item');

    $gifts.addClass('loading');
    $removeButton.click();
  }

  //===========================================================================
  // Enables the checkout button
  //===========================================================================

  enableCheckoutButton() {
    const $btn = $('.js-checkout-btn');
    $btn.prop('disabled', false);
  }

  //===========================================================================
  // Disables the checkout button
  //===========================================================================

  disableCheckoutButton() {
    const $btn = $('.js-checkout-btn');
    $btn.prop('disabled', true);
  }

  //===========================================================================
  // Automatically applies a discount code to checkout
  //===========================================================================

  applyDiscountToCheckout(e) {
    const $target  = $(e.currentTarget);
    const discount = $target.data('discount-code');
    const url = `/discount/${ discount }?redirect=/checkout?${ this.getGaLinker() }`;

    if (discount) {
      e.preventDefault();
      document.location.href = url;
    }
  }

  //===========================================================================
  // An alias for the checkout button
  //===========================================================================

  checkoutBtnAlias() {
    $('.js-checkout-btn').click();
  }

  //===========================================================================
  // Gets a url linker string for Google Analytics
  //===========================================================================

  getGaLinker() {
    try {
      return [window.ga.getAll()[0].get('linkerParam')];
    } catch (e) {
      return [];
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-cart-toggle', this.toggleCartDrawer.bind(this));
    $(document).on('click', '.js-remove-cart-item', this.removeCartItem.bind(this));
    $(document).on('click', '.js-update-cart-quantity', this.updateQuantityFromClick.bind(this));
    $(document).on('click', '.js-cart-gift-toggle', this.toggleGiftForm.bind(this));
    $(document).on('click', '.js-checkout-btn-discount', this.applyDiscountToCheckout.bind(this));
    $(document).on('click', '.js-checkout-alias', this.checkoutBtnAlias.bind(this));
    $(document).on('click', '.js-cart-page .js-accordion-header', this.checkAccordionModuleStatus.bind(this));
    $(document).on('change', '.js-cart-sample-checkbox', this.onSampleSelection.bind(this));
    $(document).on('change', '.js-cart-gwp-checkbox', this.onGwpSelection.bind(this));
    $(document).on('change', '.js-cart-gift-uncheckbox', this.onGiftUnselect.bind(this));
    $(document).on('input', '.js-cart-drawer-form-gift-input', this.checkIfGiftFormIsValid.bind(this));
    $(document).on('cartOpen', this.openCartDrawer.bind(this));
    $(document).on('cartClose', this.closeCartDrawer.bind(this));
    $(document).on('cartRefresh', this.refreshCart.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
  }
}
